import { useState } from "react";
import { Link } from "react-router-dom";
import { Card } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { Sparkles, ChevronDown, ChevronUp, X, ArrowRight } from "lucide-react";
import { NOVITA, NOVITA_VERSIONE } from "@/data/novita";

const KEY = "rh_novita_vista";

export const Novita = () => {
  const [hidden, setHidden] = useState(localStorage.getItem(KEY) === NOVITA_VERSIONE);
  const [open, setOpen] = useState(false);

  if (hidden) return null;
  const nuove = NOVITA.filter((n) => n.v === NOVITA_VERSIONE);
  const lista = open ? NOVITA : nuove;

  const chiudi = () => {
    localStorage.setItem(KEY, NOVITA_VERSIONE);
    setHidden(true);
  };

  return (
    <Card className="border-amber-200 bg-amber-50/60 p-5" data-testid="novita-card">
      <div className="flex items-start justify-between gap-3">
        <div className="flex items-center gap-2">
          <Sparkles className="h-4 w-4 text-amber-600" />
          <div>
            <p className="text-[10px] font-bold uppercase tracking-[0.2em] text-amber-700">Novità</p>
            <h3 className="text-lg font-semibold">Cosa c'è di nuovo nella versione {NOVITA_VERSIONE}</h3>
          </div>
        </div>
        <button onClick={chiudi} className="rounded-full p-2.5 text-amber-700 hover:bg-amber-100" data-testid="novita-close" aria-label="Nascondi novità">
          <X className="h-4 w-4" />
        </button>
      </div>

      <ul className="mt-4 space-y-3">
        {lista.map((n) => (
          <li key={n.titolo} className="rounded-xl bg-white/80 p-4" data-testid={`novita-item-${n.titolo.slice(0, 12)}`}>
            <div className="flex items-baseline justify-between gap-2">
              <p className="text-sm font-semibold">{n.titolo}</p>
              <span className="font-num text-[11px] text-slate-400">{n.data}</span>
            </div>
            <p className="mt-1 text-sm text-slate-600">{n.testo}</p>
            <Link to={n.to} className="mt-2 inline-flex items-center gap-1 text-sm font-medium text-amber-800 hover:underline">
              {n.cta} <ArrowRight className="h-3.5 w-3.5" />
            </Link>
          </li>
        ))}
      </ul>

      <Button variant="ghost" size="sm" className="mt-3 text-amber-800" onClick={() => setOpen(!open)} data-testid="novita-toggle">
        {open ? <ChevronUp className="mr-1 h-4 w-4" /> : <ChevronDown className="mr-1 h-4 w-4" />}
        {open ? "Mostra solo le ultime" : "Vedi tutte le novità"}
      </Button>
    </Card>
  );
};
